import { TextFieldModule } from '@angular/cdk/text-field';
import { booleanAttribute, Component, effect, ElementRef, input, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCheck, lucidePen, lucideTrash, lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { Compétence } from '../../../croisement-référentiel/models/compétences';

@Component({
  selector: 'app-competence',
  imports: [NgIcon, HlmButtonImports, HlmIconImports, FormsModule, TextFieldModule, ...HlmTooltipImports],
  templateUrl: './competence.component.html',
  providers: [provideIcons({ lucideCheck, lucideTrash, lucidePen, lucideX })],
})
export class CompetenceComponent {
  readonly _competence = input.required<Compétence>({ alias: 'competence' });
  readonly canEdit = input<boolean, boolean | string>(false, { transform: booleanAttribute });

  readonly competenceChange = output<Compétence>();
  readonly onDelete = output();

  readonly textarea = viewChild<ElementRef<HTMLTextAreaElement>>('textAreaCompetence');

  competence!: Compétence;

  constructor() {
    effect(() => {
      const competence = this._competence();
      if (competence) {
        this.competence = structuredClone(competence);
      }
    });
  }

  toggleValidation() {
    const competence = this.competence;
    if (!competence.estValidee && !competence.libelle.trim()) {
      this.focusTextarea();
      return;
    }
    competence.estValidee = !competence.estValidee;

    if (!competence.estValidee) {
      setTimeout(() => this.focusTextarea());
    } else {
      this.competenceChange.emit(competence);
    }
  }

  focusTextarea = () => this.textarea()?.nativeElement.focus();

  cancel() {
    if (this.competence.libelle.trim() === '' && this._competence().libelle.trim() === '') {
      this.delete();
      return;
    }
    this.competence = structuredClone(this._competence());
  }

  delete = () => this.onDelete.emit();
}
